import phoneNumberData from '@homeaway/react-input-tel/lib/transpiled/components/InputTel/phoneNumberData.json';
import {get, isEmpty} from 'lodash';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
import {QUEBEC_COUNTRY_CODE, QUEBEC_STATE_CODE, BILLING} from '../utils/constants';

const isVatForGermany = (countryCode) => countryCode === 'DE';

const getAlteredVatRegions = (vatCountryDetails) => {
    if (isVatForGermany(vatCountryDetails.countryCode)) {
        const specialRegionList = vatCountryDetails.specialRegion;

        specialRegionList.forEach((specialRegion) => {
            if (specialRegion.specialRegionCode === 'busingen') {
                specialRegion.specialRegionDisplayName = 'Büsingen';
            } else if (specialRegion.specialRegionCode === 'heligoland') {
                specialRegion.specialRegionDisplayName = 'Helgoland';
            }
        });
    }
};

const checkForIncompleteForm = (formData) => {
    let isFormEmpty = false;
    const arrayConstructor = [].constructor;

    for (const key in formData) {
        if (Object.prototype.hasOwnProperty.call(formData, key)) {
            const formValue = (formData[key].constructor === arrayConstructor) ? formData[key][0] : formData[key];
            if (!formValue.trim() || formValue === '–') {
                isFormEmpty = true;
                break;
            }
        }
    }

    return isFormEmpty;
};

const getDialingCountryCode = (dialingPhoneCode, countryCode) => {
    let dialingCountryCode;
    if (dialingPhoneCode === '1' || dialingPhoneCode === '44') {
        if (countryCode) {
            dialingCountryCode = countryCode.toLowerCase();
        } else if (dialingPhoneCode === '1') {
            dialingCountryCode = 'us';
        } else if (dialingPhoneCode === '44') {
            dialingCountryCode = 'gb';
        }
    } else {
        for (const phoneData of phoneNumberData) {
            if (phoneData.phoneCode === dialingPhoneCode) {
                dialingCountryCode = phoneData.cc;
                break;
            }
        }
    }

    return dialingCountryCode;
};

const getCompanyLocation = (companyCountryCode, countryList) => {
    const countryCode = companyCountryCode || '';
    const companyLocation = (countryList instanceof Array) ? countryList.find((e) => e.countryCode === countryCode) : {};
    return (companyLocation) ? companyLocation.countryName : '';
};

const isQstEnabled = () => {
    const experiment = AbacusClientUtils.evaluateExperiment('ha_pso_qc_qst_flow');
    return get(experiment, 'value', 0);
};

const isQstEligible = (addresses) => {
    let isEligible = false;
    addresses.forEach((address) => {
        if (address && address.addressType === BILLING && address.country === QUEBEC_COUNTRY_CODE &&
            address.stateProvince === QUEBEC_STATE_CODE) {
            isEligible = true;
        }
    });
    return isEligible;
};

const isAddressAvailable = (userInfoMetadata) =>
    !!(userInfoMetadata.user && userInfoMetadata.user.contact && userInfoMetadata.user.contact.addresses);

const getAddressFromUserInfoByType = (userInfoMetadata, addressType) =>
    userInfoMetadata.user.contact.addresses.filter(address => (address && address.addressType === addressType));

const getAddressFromBillingInfoByType = (billingDetails, addressType) =>
    billingDetails.billingAccountInfo.billingAccountAddresses.filter((address) => (address.rel && address.rel === addressType));

const isLeadFormUserContactExists = (leadFormUserInfo) => leadFormUserInfo && leadFormUserInfo.contact && leadFormUserInfo.contact.phone;

const isLeadFormUserAddressExists = (leadFormUserInfo) => leadFormUserInfo && leadFormUserInfo.contact && leadFormUserInfo.contact.addresses && !isEmpty(leadFormUserInfo.contact.addresses);

const isSWSv2FlowEnabled = () => {
    const experiment = AbacusClientUtils.evaluateExperiment('vrbo_qc_sws_v2_flow');
    return get(experiment, 'value', 0);
};

export {
    getAlteredVatRegions,
    checkForIncompleteForm,
    getDialingCountryCode,
    getCompanyLocation,
    isQstEnabled,
    isQstEligible,
    isAddressAvailable,
    getAddressFromUserInfoByType,
    getAddressFromBillingInfoByType,
    isLeadFormUserContactExists,
    isLeadFormUserAddressExists,
    isSWSv2FlowEnabled
};
